<script setup lang="ts">
import { mdiChevronDown } from "@mdi/js";

interface Props {
	expandable?: boolean;
	initialState?: boolean;
}

const props = defineProps<Props>();

const active = ref(props.initialState);
const observer = ref<IntersectionObserver>();
const container = ref<HTMLElement>();
const loaded = ref<boolean>(true);

// onMounted(() => {
// 	if (container.value && "IntersectionObserver" in window) {
// 		const containerObserver = (entries: Array<IntersectionObserverEntry>) => {
// 			entries.forEach(function (entry) {
// 				loaded.value = entry.isIntersecting;
// 			});
// 		};
// 		observer.value = new IntersectionObserver(containerObserver, { threshold: 0.1 });
// 		observer.value.observe(container.value);
// 	}
// });

const changeState = () => {
	if (props.expandable) {
		active.value = !active.value;
	}
};

onUnmounted(() => {
	if (observer.value) {
		observer.value.disconnect();
	}
});
</script>

<template>
	<div ref="container">
		<div v-if="loaded || active" class="w-full bg-light-200 dark:bg-dark-800 text-dark-800 dark:text-light-50 text-xs min-h-[32px] relative">
			<div @click="changeState" class="w-full p-2 border-b cursor-pointer bg-light-50 dark:bg-dark-600 border-b-light-400 dark:border-b-dark-500">
				<slot name="header" />
			</div>
			<div v-if="expandable" class="absolute top-[1px] right-0 w-[42px] h-[40px] flex items-center justify-center pointer-events-none">
				<UiIcon :path="mdiChevronDown" :class="['w-6 h-6 fill-dark-800 transition-all dark:fill-light-50', active ? 'transform rotate-180' : '']" />
			</div>
			<slot v-if="active" />
		</div>
		<div v-else class="w-full h-[41px]"></div>
	</div>
</template>
